import classnames from "classnames";
import type { FunctionComponent } from "react";

import type { SelectionConnectorProps } from "./props";
import styles from "./SelectionConnector.web.css";

export const SelectionConnector: FunctionComponent<SelectionConnectorProps> = ({ variant }) => {
  const hasTopLine = variant === "middle" || variant === "bottom";
  const hasBottomLine = variant === "top" || variant === "middle";

  return (
    <span className={styles.container} aria-hidden="true">
      <span className={styles.lineContainer}>
        <span className={classnames(styles.line, !hasTopLine && styles.hidden)} />
        <span className={styles.dot} />
        <span className={classnames(styles.line, !hasBottomLine && styles.hidden)} />
      </span>
    </span>
  );
};
